import { STORAGE_PREFIX as prefix } from './redux';
//import * as constants from './constants';

export const getInfluencers = state => state[prefix].influencers;

